export default __webpack_public_path__ + "static/media/react-native.9accb751.gif";